import * as S from './styles'

export const AppearFromDown = ({ children }: { children: React.ReactNode }) => {
  return <S.Container>{children}</S.Container>
}
